document.addEventListener("DOMContentLoaded", function () {
  const detailsList = document.querySelectorAll('details[id^="faq-item-"]');

  detailsList.forEach((details) => {
    details.addEventListener("toggle", function () {
      if (details.open) {
        detailsList.forEach((other) => {
          if (other !== details && other.open) {
            other.removeAttribute("open");
          }
        });
      }
    });
  });
});
